import React from "react";
import { Menu } from "lucide-react";
import AppMenu from "@/components/AppMenu";
import Logo from "@/components/Logo";

// Rebuilt navbar for the inner (Contact / Case Studies) pages:
// logo on the left, working hamburger menu on the right.
export default function SiteNavbar() {
  return (
    <header className="w-full bg-[#0a1f3d]">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-5 sm:px-8">
        <Logo />

        <AppMenu
          trigger={
            <button
              aria-label="Open menu"
              className="flex h-11 w-11 items-center justify-center rounded-md text-white transition-colors hover:bg-white/10"
            >
              <Menu className="h-7 w-7" />
            </button>
          }
        />
      </div>
    </header>
  );
}
